/*! custom_testimonials-slider v8
  Slider infini — rotation de groupes, identique au slider UGC natif.
  3 groupes position:absolute animés via translate3d.
  _rebalanceGroups() appelé chaque frame (pattern UGC) :
    détecte quel groupe est le plus proche du centre viewport,
    téléporte l'autre groupe hors-écran de l'autre côté — invisiblement.
  Drag / molette : même logique que custom_ugc-slider.js (verrou d'axe, seuils,
    touch-action, momentum molette).
*/
(function () {
  'use strict';

  /* ─── Délai relatif dynamique (« Il y a … ») ──────────────────────────────
     Calculé côté client car dynamique : à partir de data-delay-date, l'affichage
     démarre à data-delay-min (jours) et avance d'un jour chaque jour jusqu'à
     data-delay-max, puis revient au min (cycle). Affichage toujours relatif ;
     > 7 jours → « semaine(s) », > 28 jours → « mois ». Mots en français (thème FR).
  ─────────────────────────────────────────────────────────────────────────── */
  function formatRelativeDelay(days) {
    if (days <= 0) return 'Aujourd’hui';
    // < 7 j → jours ; 7–27 j → semaines (palier plein : 7=1, 14=2, 21=3) ;
    // ≥ 28 j → mois (28=1, puis chaque tranche de 30 j : 60=2, 90=3, …).
    if (days < 7) return 'Il y a ' + days + ' jour' + (days > 1 ? 's' : '');
    if (days < 28) {
      var w = Math.floor(days / 7);
      return 'Il y a ' + w + ' semaine' + (w > 1 ? 's' : '');
    }
    var m = Math.max(1, Math.floor(days / 30));
    return 'Il y a ' + m + ' mois';
  }

  function computeDelayText(dateStr, minRaw, maxRaw) {
    if (!dateStr) return '';
    var start = new Date(dateStr + 'T00:00:00');
    if (isNaN(start.getTime())) return '';
    var min = parseInt(minRaw, 10); if (isNaN(min) || min < 0) min = 0;
    var max = parseInt(maxRaw, 10); if (isNaN(max) || max < min) max = min;
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var daysSince = Math.floor((today - start) / 86400000);
    if (daysSince < 0) daysSince = 0;
    var range = (max - min) + 1;
    var displayed = min + (daysSince % range);
    return formatRelativeDelay(displayed);
  }

  function fillTestimonialDelays(root) {
    var nodes = (root || document).querySelectorAll('[data-testimonial-delay]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.delayFilled === 'true') continue;
      var txt = computeDelayText(el.getAttribute('data-delay-date'), el.getAttribute('data-delay-min'), el.getAttribute('data-delay-max'));
      if (txt) { el.textContent = txt; el.dataset.delayFilled = 'true'; }
    }
  }

  class TestimonialsSlider extends HTMLElement {

    connectedCallback() {
      this.viewport = this.querySelector('.testimonials-slider__viewport');
      this.track    = this.querySelector('.testimonials-slider__track');
      if (!this.viewport || !this.track) return;

      // [CUSTOM] Rotation par lots (display_count) : on retire du DOM les cartes hors du
      // lot courant avant de construire les groupes. Le lot courant est calculé depuis
      // data-batch-ref (date de référence) et data-batch-cycle (= delay_max en jours).
      var displayCount = parseInt(this.getAttribute('data-display-count') || '0', 10);
      var batchRef   = this.getAttribute('data-batch-ref') || '';
      var refDate    = batchRef ? new Date(batchRef + 'T00:00:00') : null;
      // [CUSTOM] La rotation ne s'applique QUE si une date de référence valide existe
      // (réglage du bloc pilote, sinon 1re date trouvée parmi les cartes). Sans date,
      // aucune rotation ni troncature : toutes les cartes (datées ou non) restent affichées.
      if (displayCount > 0 && refDate && !isNaN(refDate.getTime())) {
        var batchCycle = Math.max(1, parseInt(this.getAttribute('data-batch-cycle') || '1', 10));
        var currentBatch = 0;
        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var daysSince = Math.max(0, Math.floor((today - refDate) / 86400000));
        var allBatchCards = this.track.querySelectorAll('[data-base][data-batch-index]');
        var numBatches = Math.ceil(allBatchCards.length / displayCount);
        if (numBatches > 0) currentBatch = Math.floor(daysSince / batchCycle) % numBatches;
        var toRemove = this.track.querySelectorAll('[data-base][data-batch-index]');
        for (var ri = 0; ri < toRemove.length; ri++) {
          var bIdx = parseInt(toRemove[ri].getAttribute('data-batch-index') || '0', 10);
          if (Math.floor(bIdx / displayCount) !== currentBatch) {
            toRemove[ri].parentNode && toRemove[ri].parentNode.removeChild(toRemove[ri]);
          }
        }
      }

      // [CUSTOM] Sélecteur générique : tout enfant marqué data-base="true" du track.
      // Permet de réutiliser le slider infini pour d'autres cartes (multicolumn-card, etc.).
      this.baseCards = Array.from(
        this.track.querySelectorAll('[data-base]')
      );
      if (!this.baseCards.length) return;

      this._pos     = 0;
      this._span    = 0;
      this._animRaf = null;
      this._groups  = [];
      this._dragging = false;

      this.track.style.visibility = 'hidden';

      // [CUSTOM] Index de carte : repris par les clones (cloneNode copie le data-attr).
      // Permet de synchroniser l'état « Voir plus / Voir moins » entre une carte et
      // ses duplicatas dans le slider infini.
      this.baseCards.forEach((c, i) => { c.dataset.cardIndex = String(i); });

      // [CUSTOM] Remplit les délais AVANT le clonage : les clones héritent du texte.
      fillTestimonialDelays(this);

      if (this.baseCards.length > 1) this._buildGroups();
      // [CUSTOM] Contexte produit : largeur des cartes pilotée en pixels (pas de
      // dépendance au cqw, qui ne se résout pas de façon fiable dans des groupes
      // position:absolute → cartes 0px → groupes empilés).
      this._applyProductCardWidth();

      this._onPrev = this._prev.bind(this);
      this._onNext = this._next.bind(this);
      this._bindEvents();

      requestAnimationFrame(() => requestAnimationFrame(() => {
        this._init();
        this.track.style.visibility = '';
        this._updateIndicators();
        requestAnimationFrame(() => this._refreshCompactDescriptions());
      }));

      // [CUSTOM] Le viewport ne déclenche un recalcul complet (_onResize, qui
      // remet _pos à 0) que sur un changement de LARGEUR. Un changement de hauteur
      // seul (description « Voir plus », init compact) ne doit pas réinitialiser
      // la position du slider.
      this._lastViewportWidth = this.viewport.clientWidth;
      this._ro = new ResizeObserver(() => {
        clearTimeout(this._roTimer);
        this._roTimer = setTimeout(() => {
          const w = this.viewport.clientWidth;
          if (w !== this._lastViewportWidth) {
            this._lastViewportWidth = w;
            this._onResize();
          } else {
            // Hauteur seule (ex. « Voir plus ») : on resynchronise span + hauteur
            // SANS réinitialiser la position.
            this._syncMetrics();
          }
        }, 100);
      });
      this._ro.observe(this.viewport);

      // [CUSTOM] Hauteur dynamique : on observe les groupes (qui s'étirent à la
      // hauteur de leur plus grande carte). À chaque variation (collapse compact,
      // ouverture/fermeture « Voir plus »), on resynchronise la hauteur du track
      // sans toucher à la position. → toutes les cartes prennent la hauteur de la
      // plus grande, et le slider grandit/diminue avec le contenu déplié.
      this._observeGroups();
    }

    // [CUSTOM] Largeur d'une carte en px, en contexte fiche produit uniquement
    // (classe product__testimonials). Ratios identiques au balayage mobile de la
    // section : data-cols-mobile 1 / 1,5 / 2 → 74 / 55 / 36 % du viewport.
    _applyProductCardWidth() {
      if (!this.classList.contains('product__testimonials')) return;
      const ratioMap = { '1': 0.74, '1.5': 0.55, '2': 0.36 };
      // [CUSTOM] Le réglage « cartes visibles » ne s'applique que sur desktop (≥1024px).
      // Sur mobile/tablette, on reste toujours à 1 carte.
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      const cols = isDesktop ? (this.track.dataset.colsMobile || '1') : '1';
      const ratio = ratioMap[cols] || 0.74;
      const w = this.viewport.clientWidth * ratio;
      if (w > 0) this.track.style.setProperty('--tcard-w', Math.round(w) + 'px');
    }

    // [CUSTOM] Recalcule les descriptions compactes une fois la largeur des cartes
    // résolue. Chaque carte (originale ou clone) est initialisée indépendamment.
    _refreshCompactDescriptions() {
      if (window.__stoyikCompactDescription) {
        window.__stoyikCompactDescription.refresh(this);
      }
    }

    _observeGroups() {
      if (this.baseCards.length <= 1 || !this._groups.length) return;
      // Observe les groupes : à chaque variation de taille (mise en page initiale
      // qui résout enfin la largeur des cartes cqw, collapse compact, ouverture
      // « Voir plus »…) on resynchronise span + hauteur. C'est cette autocorrection
      // qui évite que les 3 groupes restent empilés à la position 0 quand la mesure
      // initiale du span est faite trop tôt. Mise à jour par frame (pas de debounce).
      this._groupRo = new ResizeObserver(() => {
        if (this._syncRaf) cancelAnimationFrame(this._syncRaf);
        this._syncRaf = requestAnimationFrame(() => this._syncMetrics());
      });
      this._groups.forEach(g => this._groupRo.observe(g.el));
    }

    // [CUSTOM] Hauteur du track = hauteur du groupe le PLUS HAUT (et non uniquement
    // _groups[1]). Déplier « Voir plus » ne fait grandir que le groupe qui contient la
    // carte cliquée ; or ce n'est pas toujours _groups[1] : en mode 2 groupes (cartes
    // larges → mobile), la carte visible est dans _groups[0] tandis que _groups[1] est
    // le duplicata hors-écran resté replié. Mesurer seulement _groups[1] laissait alors
    // le track trop court → l'expansion était rognée par le viewport (overflow:hidden)
    // → « Voir plus » ne déroulait pas sur mobile. Le max couvre les modes 2 et 3 groupes.
    _tallestGroupHeight() {
      return this._groups.reduce(
        (max, g) => Math.max(max, g.el.offsetHeight),
        0,
      );
    }

    // Resynchronise la largeur d'un groupe (span) et la hauteur du track, en
    // PRÉSERVANT la position courante. Ne réapplique les transforms que si le span
    // a réellement changé (évite tout travail superflu pendant l'animation verticale
    // de « Voir plus », où seul la hauteur bouge).
    _syncMetrics() {
      if (this.baseCards.length <= 1 || !this._groups[1]) return;
      const newSpan = this._calcSpan();
      if (newSpan > 0 && Math.abs(newSpan - this._span) > 0.5) {
        this._span = newSpan;
        this._normalize();
        this._applyTransforms();
        this._refreshCompactDescriptions();
      }
      this.track.style.height = this._tallestGroupHeight() + 'px';
    }

    disconnectedCallback() {
      this.removeEventListener('slider:previous', this._onPrev);
      this.removeEventListener('slider:next',     this._onNext);
      if (this._ro) this._ro.disconnect();
      if (this._groupRo) this._groupRo.disconnect();
      clearTimeout(this._roTimer);
      if (this._animRaf) cancelAnimationFrame(this._animRaf);
      if (this._syncRaf) cancelAnimationFrame(this._syncRaf);
    }

    // [CUSTOM] Reconstruit la mise en page une fois le slider réellement mesurable.
    // Le cart drawer est content-visibility:hidden tant qu'il est fermé (cf.
    // .drawer[hidden]) : les groupes multi-cartes construits à l'init mesurent alors
    // une largeur nulle → groupCount/copies collapsés → les témoignages n'apparaissent
    // pas à l'ouverture (une seule carte n'utilise pas les groupes, d'où l'OK à l'unité).
    // Appelée par CartDrawer.show() (même correctif que refreshRecommendations dans
    // cart.js). No-op tant que la largeur est nulle, ou à l'unité (pas de groupes).
    refresh() {
      if (!this.viewport || !this.track || !this.baseCards) return;
      if (this.baseCards.length <= 1 || this.viewport.clientWidth === 0) return;
      if (this._groupRo) this._groupRo.disconnect();
      this._buildGroups();
      this._init();
      this.track.style.visibility = '';
      this._lastViewportWidth = this.viewport.clientWidth;
      this._updateIndicators();
      this._observeGroups();
      this._refreshCompactDescriptions();
    }

    /* ─── Construction des 3 groupes ─────────────────────────────────────── */

    _buildGroups() {
      // [CUSTOM] Duplication adaptative — même logique que custom_ugc-slider.js.
      // 1. Mesure d'abord la largeur réelle d'une carte : on place les originales
      //    dans un groupe provisoire (la largeur produit --tcard-w / les règles CSS
      //    ne s'appliquent qu'à une carte DANS un groupe).
      const measureGroup = document.createElement('div');
      measureGroup.className = 'testimonials-slider__group';
      this.baseCards.forEach(c => measureGroup.appendChild(c));
      this.track.innerHTML = '';
      this.track.appendChild(measureGroup);
      this._applyProductCardWidth();

      const gap = parseFloat(getComputedStyle(measureGroup).gap) || 0;
      const cardW = this.baseCards[0].getBoundingClientRect().width || 1;
      const count = this.baseCards.length;
      const vpW = this.viewport.getBoundingClientRect().width || 0;
      const sequenceUnit = (cardW + gap) * Math.max(1, count);

      // duplicationRaw = combien de fois la séquence tient dans ~55% du viewport.
      // < 0.5 (cartes larges, peu nombreuses) → 2 groupes d'1 copie (mode « full »).
      // ≥ 0.5 (cartes étroites) → 3 groupes de ceil(dup) copies (mode « duplicate »).
      const dupRaw = sequenceUnit ? (vpW * 0.55) / sequenceUnit : 0;
      let groupCount, copies;
      if (dupRaw < 0.5) { groupCount = 2; copies = 1; }
      else { groupCount = 3; copies = Math.ceil(Math.max(1, dupRaw)); }

      // 2. Construit les groupes définitifs. Les cartes originales (interactives,
      //    shopify_attributes) sont placées dans le 1er groupe, 1re copie ; le reste
      //    est cloné. data-card-index (déjà posé) est copié → synchro « Voir plus ».
      this._groups = [];
      for (let gi = 0; gi < groupCount; gi += 1) {
        const el = document.createElement('div');
        el.className = 'testimonials-slider__group';
        this._groups.push({ el, index: 0 });
      }
      for (let gi = 0; gi < groupCount; gi += 1) {
        for (let cp = 0; cp < copies; cp += 1) {
          this.baseCards.forEach(c => {
            if (gi === 0 && cp === 0) {
              this._groups[gi].el.appendChild(c);
            } else {
              const clone = c.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('data-base');
              // [CUSTOM] Les clones ne doivent pas dupliquer les titres sémantiques (Hn) :
              // on les remplace par un <div> visuellement identique (mêmes classes/contenu).
              clone.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(h => {
                const div = document.createElement('div');
                if (h.className) div.className = h.className;
                div.innerHTML = h.innerHTML;
                h.parentNode.replaceChild(div, h);
              });
              this._groups[gi].el.appendChild(clone);
            }
          });
        }
      }

      this.track.innerHTML = '';
      this._groups.forEach(g => this.track.appendChild(g.el));
      this._reindex();
    }

    /* ─── Init et resize ─────────────────────────────────────────────────── */

    _init() {
      this._applyProductCardWidth();
      if (this.baseCards.length > 1) {
        this._span = this._calcSpan();
        this.track.style.height = this._tallestGroupHeight() + 'px';
        this._pos = 0;
      }
      this._applyTransforms();
      // [CUSTOM] Position de repos : 1re carte collée à gauche (mode 2 groupes inclus).
      this._snapToCard();
    }

    _onResize() {
      if (this.baseCards.length <= 1) return;
      this._applyProductCardWidth();
      this._span = this._calcSpan();
      this.track.style.height = this._tallestGroupHeight() + 'px';
      this._pos = 0;
      this._applyTransforms();
      this._snapToCard();
      this._refreshCompactDescriptions();
    }

    /* ─── Mesures ────────────────────────────────────────────────────────── */

    _calcSpan() {
      const gap = parseFloat(getComputedStyle(this._groups[1].el).gap) || 0;
      return this._groups[1].el.offsetWidth + gap;
    }

    _cardWidth() {
      const gap = parseFloat(getComputedStyle(this._groups[1]?.el || this.track).gap) || 0;
      return (this.baseCards[0]?.offsetWidth || 0) + gap;
    }

    _step() {
      const cw = this._cardWidth();
      if (!cw) return 0;
      return cw * Math.max(1, Math.floor(this.viewport.clientWidth / cw));
    }

    _reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* ─── Rotation des groupes ────────────────────────────────────────────── */

    _normalize() {
      if (!this._span || this._groups.length < 2) return;
      while (this._pos >= this._span) { this._pos -= this._span; this._shiftLeft(); }
      while (this._pos < 0)           { this._pos += this._span; this._shiftRight(); }
    }

    _shiftLeft()  { this._groups.push(this._groups.shift()); this._reindex(); }
    _shiftRight() { this._groups.unshift(this._groups.pop()); this._reindex(); }

    _reindex() {
      const mid = (this._groups.length - 1) / 2;
      this._groups.forEach((g, i) => { g.index = i - mid; });
    }

    /* ─── Rééquilibrage visuel chaque frame (pattern UGC) ─────────────────
       Détermine quel groupe est le plus proche du centre du viewport,
       le met en index 0 (central), place les deux autres à gauche/droite.
       Le groupe qui se retrouve de l'autre côté était hors-écran → invisible.
    ─────────────────────────────────────────────────────────────────────── */

    _rebalanceGroups() {
      if (!this._span || this._groups.length < 2) return;

      const vpRect   = this.viewport.getBoundingClientRect();
      const vpCenter = vpRect.left + vpRect.width / 2;

      const entries = this._groups.map(g => {
        const r = g.el.getBoundingClientRect();
        return { g, center: r.left + r.width / 2 };
      });

      if (this._groups.length === 3) {
        const sorted  = entries.slice().sort((a, b) => a.center - b.center);
        const central = sorted.reduce((best, cur) =>
          Math.abs(cur.center - vpCenter) < Math.abs(best.center - vpCenter) ? cur : best
        , sorted[0]);

        const ci    = sorted.indexOf(central);
        const left  = sorted[(ci - 1 + 3) % 3];
        const right = sorted[(ci + 1) % 3];

        if (
          this._groups[0] === left.g &&
          this._groups[1] === central.g &&
          this._groups[2] === right.g
        ) return;

        this._groups = [left.g, central.g, right.g];
        this._reindex();
        // Recalcule _pos pour que la transform du groupe central reste inchangée
        const tx = this._extractTranslateX(central.g.el);
        this._pos = central.g.index * this._span - tx; // index est 0 après reindex
      } else {
        // [CUSTOM] 2 groupes (mode « full ») — logique UGC : le groupe le plus proche
        // du centre est « primaire » ; on place l'autre (le doublon) du côté opposé.
        const primary = entries.reduce((best, cur) =>
          Math.abs(cur.center - vpCenter) < Math.abs(best.center - vpCenter) ? cur : best
        , entries[0]);
        const duplicate = entries.find(e => e !== primary) || primary;

        const delta = primary.center - vpCenter;
        if (Math.abs(delta) <= 8) return; // zone morte (évite les bascules nerveuses)

        // index -0.5 = à gauche du centre, +0.5 = à droite (cf. _reindex).
        const desired = delta < 0 ? [primary.g, duplicate.g] : [duplicate.g, primary.g];
        if (desired[0] === this._groups[0] && desired[1] === this._groups[1]) return;

        this._groups = desired;
        this._reindex();
        const tx = this._extractTranslateX(primary.g.el);
        this._pos = primary.g.index * this._span - tx; // transform du primaire préservée
      }
    }

    _extractTranslateX(el) {
      const m = el?.style?.transform?.match(/translate3d\((-?[\d.]+)px/);
      return m ? parseFloat(m[1]) : 0;
    }

    /* ─── Transforms (double passe, identique UGC) ────────────────────────── */

    _applyTransforms() {
      if (!this._groups.length) return;
      const apply = () => {
        const span = this._span, pos = this._pos;
        this._groups.forEach(g => {
          g.el.style.transform = `translate3d(${g.index * span - pos}px,0,0)`;
        });
      };
      apply();
      if (this._groups.length >= 2 && this._span) {
        this._rebalanceGroups();
        apply();
      }
    }

    /* ─── Navigation animée ──────────────────────────────────────────────── */

    _prev() { this._animateDelta(-this._step()); }
    _next() { this._animateDelta(this._step()); }

    _animateDelta(totalDelta) {
      if (!totalDelta || !this._span) return;
      if (this._reducedMotion()) {
        this._pos += totalDelta;
        this._normalize();
        this._applyTransforms();
        return;
      }

      if (this._animRaf) cancelAnimationFrame(this._animRaf);
      const duration = 420, start = performance.now();
      let applied = 0;

      const tick = (now) => {
        const t     = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 3);
        const delta = totalDelta * eased - applied;
        applied    += delta;
        this._pos  += delta;
        this._normalize();
        this._applyTransforms();

        if (t < 1) {
          this._animRaf = requestAnimationFrame(tick);
        } else {
          this._animRaf = null;
          this._snapToCard();
        }
      };
      this._animRaf = requestAnimationFrame(tick);
    }

    // [CUSTOM] Magnétisme « collé à gauche » : delta de position pour amener la carte
    // la plus proche du bord gauche pile sur le bord de contenu du viewport.
    // Géométrique (lit les rects réels) → valable en 2 OU 3 groupes, contrairement à
    // l'ancien round(pos/cw)*cw qui ne tombait juste qu'avec des index entiers (3 groupes).
    _leftFlushDelta() {
      const cards = this.track.querySelectorAll('.testimonial-card, .multicolumn-card');
      if (!cards.length) return 0;
      const padLeft = parseFloat(getComputedStyle(this.viewport).paddingLeft) || 0;
      const vpLeft = this.viewport.getBoundingClientRect().left + padLeft;
      let best = 0, bestAbs = Infinity;
      cards.forEach(card => {
        const delta = card.getBoundingClientRect().left - vpLeft;
        if (Math.abs(delta) < bestAbs) { bestAbs = Math.abs(delta); best = delta; }
      });
      return best;
    }

    _snapToCard() {
      const diff = this._leftFlushDelta();
      if (Math.abs(diff) > 0.5) {
        this._pos += diff;
        this._normalize();
        this._applyTransforms();
      }
    }

    _snapToCardAnimated() {
      const diff = this._leftFlushDelta();
      if (Math.abs(diff) > 0.5) this._animateDelta(diff);
    }

    _startMomentum(initialVelocity) {
      if (!initialVelocity || !this._span) {
        this._snapToCardAnimated();
        return;
      }

      if (this._reducedMotion()) {
        this._snapToCardAnimated();
        return;
      }

      if (this._animRaf) cancelAnimationFrame(this._animRaf);

      let velocity = initialVelocity; // px/s
      let lastTs = performance.now();
      const minVelocity = 20; // seuil d'arrêt (px/s)
      const frictionPerFrame = 0.92; // ressenti plus naturel sur mobile

      const tick = (now) => {
        const dt = Math.max(1, now - lastTs);
        lastTs = now;

        this._pos += velocity * (dt / 1000);
        this._normalize();
        this._applyTransforms();

        const friction = Math.pow(frictionPerFrame, dt / 16.67);
        velocity *= friction;

        if (Math.abs(velocity) > minVelocity) {
          this._animRaf = requestAnimationFrame(tick);
        } else {
          this._animRaf = null;
          this._snapToCardAnimated();
        }
      };

      this._animRaf = requestAnimationFrame(tick);
    }

    /* ─── Drag ────────────────────────────────────────────────────────────
       touch-action: pan-y (CSS) délègue la discrimination verticale/horizontale
       au navigateur : swipe vertical → pointercancel → slider immobile.
       setPointerCapture uniquement pour la souris (tracking hors-viewport).
    ─────────────────────────────────────────────────────────────────────── */

    _bindDrag() {
      const TOUCH_ACTION_DEFAULT = 'pan-y pinch-zoom';
      const TOUCH_ACTION_LOCKED = 'none';
      const MOMENTUM_MAX = 2400;
      const MOMENTUM_EPSILON = 20;
      const setTouchAction = (value) => {
        this.viewport.style.touchAction = value;
        this.viewport.style.webkitTouchAction = value;
      };

      let pointerActive = false;
      let pointerDragging = false;
      let pointerCaptured = false;
      let pointerId = null;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let lastX = 0;
      let lastY = 0;
      let lastMoveTs = 0;
      let velocityX = 0;
      let dragDistance = 0;
      let scrollLock = null;

      setTouchAction(TOUCH_ACTION_DEFAULT);

      const resetPointerState = (event) => {
        if (pointerCaptured && event) {
          try { this.viewport.releasePointerCapture(event.pointerId); } catch (_) {}
        }
        pointerActive = false;
        pointerDragging = false;
        pointerCaptured = false;
        pointerId = null;
        velocityX = 0;
        scrollLock = null;
        this._dragging = false;
        if (!this._wheelAxisLocked) {
          setTouchAction(TOUCH_ACTION_DEFAULT);
        }
      };

      const onDown = (e) => {
        if (typeof e.button !== 'undefined' && e.button !== 0) return;
        // [CUSTOM] Appui sur « Voir plus / Voir moins » : ne PAS armer le drag. Sinon,
        // un micro-mouvement du doigt (> 6px) déclenche setPointerCapture, le navigateur
        // n'émet alors aucun `click` sur le bouton → le tap ne déroule pas la description
        // sur mobile. On laisse le tap natif atteindre le bouton.
        if (e.target.closest('.product-description__btn-more, .product-description__btn-less')) {
          pointerActive = false;
          return;
        }
        if (this._animRaf) { cancelAnimationFrame(this._animRaf); this._animRaf = null; }
        pointerActive = true;
        pointerDragging = false;
        pointerId = e.pointerId;
        pointerStartX = e.clientX;
        pointerStartY = e.clientY;
        lastX = e.clientX;
        lastY = e.clientY;
        lastMoveTs = performance.now();
        velocityX = 0;
        dragDistance = 0;
        this._dragging = false;
        scrollLock = null;
        setTouchAction(TOUCH_ACTION_DEFAULT);
      };

      const onMove = (e) => {
        if (!pointerActive || e.pointerId !== pointerId) return;
        const now = performance.now();
        const deltaX = e.clientX - lastX;
        const deltaY = e.clientY - lastY;
        lastX = e.clientX;
        lastY = e.clientY;
        const dt = Math.max(now - lastMoveTs, 1);
        lastMoveTs = now;

        if (!pointerDragging) {
          const totalDeltaX = e.clientX - pointerStartX;
          const totalDeltaY = e.clientY - pointerStartY;

          if (
            Math.abs(totalDeltaX) > 6 &&
            Math.abs(totalDeltaX) > Math.abs(totalDeltaY)
          ) {
            pointerDragging = true;
            this._dragging = true;
            scrollLock = 'horizontal';
            velocityX = 0;
            setTouchAction(TOUCH_ACTION_LOCKED);
            this.viewport.setPointerCapture(pointerId);
            pointerCaptured = true;
            this._pos -= totalDeltaX;
            dragDistance += Math.abs(totalDeltaX);
            this._normalize();
            this._applyTransforms();
            if (e.pointerType === 'touch' && e.cancelable) e.preventDefault();
            return;
          }
          if (
            Math.abs(totalDeltaY) > 6 &&
            Math.abs(totalDeltaY) > Math.abs(totalDeltaX)
          ) {
            resetPointerState(e);
            return;
          }
          return;
        }

        if (
          scrollLock !== 'horizontal' &&
          Math.abs(deltaY) > Math.abs(deltaX) &&
          Math.abs(deltaY) > 2
        ) {
          resetPointerState(e);
          return;
        }

        if (e.pointerType === 'touch' && e.cancelable) {
          e.preventDefault();
        }
        dragDistance += Math.abs(deltaX);
        velocityX = deltaX / (dt / 1000);
        this._pos -= deltaX;
        this._normalize();
        this._applyTransforms();
      };

      const onUp = (e) => {
        if (!pointerActive || e.pointerId !== pointerId) return;
        if (pointerDragging) {
          const flickVelocity = Math.max(
            Math.min(velocityX, MOMENTUM_MAX),
            -MOMENTUM_MAX
          );
          if (Math.abs(flickVelocity) > MOMENTUM_EPSILON) {
            this._startMomentum(-flickVelocity);
          } else {
            this._snapToCardAnimated();
          }
        } else {
          this._snapToCardAnimated();
        }
        resetPointerState(e);
      };

      const onCancel = (e) => {
        resetPointerState(e);
      };

      this.viewport.addEventListener('pointerdown', onDown);
      this.viewport.addEventListener('pointermove', onMove);
      this.viewport.addEventListener('pointerup', onUp);
      this.viewport.addEventListener('pointercancel', onCancel);
      this.viewport.addEventListener('touchmove', (e) => {
        if (pointerDragging && scrollLock === 'horizontal' && e.cancelable) {
          e.preventDefault();
        }
      }, { passive: false });

      this.viewport.addEventListener('click', e => {
        if (e.target.closest('.product-description__btn-more, .product-description__btn-less')) {
          dragDistance = 0;
          this._dragging = false;
          return;
        }
        if (this._dragging || dragDistance > 12) {
          e.preventDefault();
          e.stopPropagation();
          this._dragging = false;
        }
        dragDistance = 0;
      }, true);

      this._wheelAxisLocked = false;
    }

    /* ─── Wheel / trackpad (identique custom_ugc-slider.js) ──────────────── */

    _bindWheel() {
      const TOUCH_ACTION_DEFAULT = 'pan-y pinch-zoom';
      const TOUCH_ACTION_LOCKED = 'none';
      const MOMENTUM_MAX = 2400;
      const MOMENTUM_EPSILON = 20;
      const setTouchAction = (value) => {
        this.viewport.style.touchAction = value;
        this.viewport.style.webkitTouchAction = value;
      };

      let inWheelHorizontal = false;
      let wheelScrollVelocity = 0;
      let wheelResumeTimer = null;

      this.viewport.addEventListener('wheel', e => {
        if (!this._span) return;

        const absX = Math.abs(e.deltaX);
        const absY = Math.abs(e.deltaY);

        if (!inWheelHorizontal && absY > absX) {
          return;
        }

        const horizontalIntent = inWheelHorizontal
          ? absX > 0 || absX + absY < 0.5
          : absX > 3 && absX >= absY;

        if (!horizontalIntent) {
          inWheelHorizontal = false;
          this._wheelAxisLocked = false;
          setTouchAction(TOUCH_ACTION_DEFAULT);
          return;
        }

        let delta = e.deltaX;
        if (e.deltaMode === 1) {
          delta *= 30;
        }
        if (!delta) return;

        if (e.cancelable) {
          e.preventDefault();
        }

        if (this._animRaf) {
          cancelAnimationFrame(this._animRaf);
          this._animRaf = null;
        }

        // _pos est l'opposé de « position » UGC (transform : index*span - pos).
        wheelScrollVelocity = wheelScrollVelocity * 0.7 + (delta * 60) * 0.3;
        inWheelHorizontal = true;
        this._wheelAxisLocked = true;
        setTouchAction(TOUCH_ACTION_LOCKED);

        this._pos += delta;
        this._normalize();
        this._applyTransforms();

        if (wheelResumeTimer) clearTimeout(wheelResumeTimer);
        wheelResumeTimer = setTimeout(() => {
          const flickVelocity = Math.max(
            Math.min(wheelScrollVelocity, MOMENTUM_MAX),
            -MOMENTUM_MAX
          );
          wheelScrollVelocity = 0;
          inWheelHorizontal = false;
          this._wheelAxisLocked = false;

          if (Math.abs(flickVelocity) > MOMENTUM_EPSILON) {
            this._startMomentum(flickVelocity);
          } else {
            this._snapToCardAnimated();
          }
          setTouchAction(TOUCH_ACTION_DEFAULT);
        }, 160);
      }, { passive: false });
    }

    /* ─── Événements ─────────────────────────────────────────────────────── */

    _bindEvents() {
      this.addEventListener('slider:previous', this._onPrev);
      this.addEventListener('slider:next',     this._onNext);

      if (this.baseCards.length > 1) {
        this._bindDrag();
        this._bindWheel();
      }

      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  { this._prev(); e.preventDefault(); }
        if (e.key === 'ArrowRight') { this._next(); e.preventDefault(); }
      });

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', e => {
          const card = e.target.closest('[data-base]');
          if (!card) return;
          const idx = this.baseCards.indexOf(card);
          if (idx < 0) return;
          this._animateDelta(idx * this._cardWidth() - this._pos);
        });
      }
    }

    _updateIndicators() {
      const status = this.baseCards.length > 1 ? 'visible' : 'hidden';
      this.dispatchEvent(new CustomEvent('slider:previousStatus', { bubbles: true, detail: { status } }));
      this.dispatchEvent(new CustomEvent('slider:nextStatus',     { bubbles: true, detail: { status } }));
    }
  }

  if (!customElements.get('testimonials-slider')) {
    customElements.define('testimonials-slider', TestimonialsSlider);
  }

  // [CUSTOM] Filet de sécurité : remplit les délais des cartes hors slider infini.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fillTestimonialDelays(document); });
  } else {
    fillTestimonialDelays(document);
  }

  // [CUSTOM] Scroll doux pour les liens d'ancre (#) dans l'en-tête du slider
  // (bouton discret fiche produit). Même pattern que le thème (header offset + motionReduced).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.product__testimonials-header .link');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    var headerEl = document.querySelector('header.header');
    var headerHeight = headerEl ? Math.round(headerEl.clientHeight) : 0;
    var top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({
      top: top,
      behavior: (window.theme && window.theme.config && window.theme.config.motionReduced) ? 'auto' : 'smooth'
    });
  });
})();
